import { useEffect, useState } from "react";
import API from "Util/Axios";

const initialState = {
  loading: true,
  error: null,
  order: null,
  maintenances: [],
  maxPhotos: 4,
};

/**
 * Assembles the exact data shape ReportDocument.js already knows how to
 * render, for the non-interactive `/print/informe/:id` page. Mirrors
 * Order/Detail/index.js's `cargar()` (order/:id/detail?full=true) +
 * `cargarMtto()` (maintenance/:id/detail per maintenance) plus Report.js's
 * config-site `maxFotosInforme` lookup — WITHOUT any of the interactive
 * photo-selection/compression/zip state those own, which is out of scope
 * for a static print snapshot.
 */
export const useOrderReportData = (orderId) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (!orderId) {
      return undefined;
    }

    let cancelled = false;
    setState(initialState);

    (async () => {
      try {
        const [{ data: detail }, configResult] = await Promise.all([
          API.get(`order/${orderId}/detail?full=true`),
          API.get("config-site").catch(() => ({ data: {} })),
        ]);

        const order = detail?.doc || {};
        const maxPhotos =
          configResult?.data?.maxFotosInforme != null
            ? Number(configResult.data.maxFotosInforme)
            : 4;

        const maintenances = await Promise.all(
          (order.maintenances || []).map(async (m) => {
            const { data } = await API.get(`maintenance/${m.maintenance}/detail`);
            return { ...m, ...data, cargado: true, visible: true };
          })
        );

        if (!cancelled) {
          setState({ loading: false, error: null, order, maintenances, maxPhotos });
        }
      } catch (error) {
        if (!cancelled) {
          setState({ loading: false, error, order: null, maintenances: [], maxPhotos: 4 });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [orderId]);

  return state;
};
